import React from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const view = ({ targetRef }) => {
    return (
        <div className="container-page">
            <div id="target" ref={targetRef}></div>
        </div>
    );
};

export default view;
